import {ObjectNumber} from 'gollumts-objecttype';
import {Game, Player} from '@/models';

import playerStore from '@/stores/modules/player';
import gameStore from '@/stores/modules/game';
import manager, {RegisteredInterface} from '@/Manager';
import {Match} from '@/models/Match';
import {Equipe} from '@/models/Equipe';

class Saver {
	
	public constructor() {
		setInterval(() => {
			this.saveCurrent();
		}, 1000);
	}
	
	public loadCurrent(): void {
		const data = this.jsonLoad(window.localStorage.getItem('currentGame'));
		
		if (!data) {
			return;
		}
		
		gameStore.commit('setGame', data.game);
		playerStore.commit('setPlayers', data.players);
	}
	
	
	public saveCurrent(): void {
		console.log('Save the current Game');
		
		const players = playerStore.state.players;
		const game = gameStore.state.game;
		
		window.localStorage.setItem(
			'currentGame',
			this.jsonSave(game, players)
		);
	}
	
	private jsonSave(game: Game, players: Player[]): string {
		
		manager.clear();
		manager.register(game);
		game.register();
		players.forEach(p => manager.register(p));
		
		const objs: ObjectNumber<RegisteredInterface> = {};
		manager.registeds.forEach(o => {
			objs[o.id] = (o);
		});
		
		return JSON.stringify({
			idGlobal: manager.idGlobal,
			objs: objs
		})
	}
	
	private jsonLoad(str: string): {game: Game, players: Player[]} {
		
		if (!str) {
			return null;
		}
		
		const json = JSON.parse(str);
		if (!json) {
			return null;
		}
		
		manager.idGlobal = json.idGlobal;
		
		let game: Game = null;
		let players: Player[] = [];
		
		for (let id in json.objs) {
			const data = json.objs[id];
			let obj: RegisteredInterface = null;
			switch (data.__className__) {
				case 'Game': obj = new Game(); game = <Game>obj; break;
				case 'Player': obj = new Player(); players.push(<Player>obj); break;
				case 'Match': obj = new Match(); break;
				case 'Equipe': obj = new Equipe(); break;
			}
			if (obj) {
				obj.id = parseInt(id, 10);
				manager.register(obj);
			} else {
				console.error('Error to unregister class', data.__className__);
			}
		}
		for (let id in json.objs) {
			const obj: any = manager.find(parseInt(id, 10));
			obj.fromJSON(json.objs[id]);
		}
		
		console.log(game);
		
		return {
			game: game,
			players: players,
		};
	}
	
}

const saver = new Saver();
export default saver;